import { Capacitor } from "@capacitor/core";

/** Muss mit AndroidManifest intent-filter + Supabase „Redirect URLs“ übereinstimmen. */
export const NATIVE_OAUTH_REDIRECT_SCHEME = "com.hustle.dance";
export const NATIVE_OAUTH_REDIRECT_HOST = "auth-callback";

export type OAuthRedirectOptions = {
  type?: "google" | "apple";
  mode?: "login" | "register";
  referralCode?: string | null;
};

/**
 * OAuth redirectTo für signInWithOAuth:
 * - Web/PWA: https-Origin + /auth/callback?…
 * - Capacitor nativ: com.hustle.dance://auth-callback?… (Deep Link zurück in die WebView)
 *
 * Plattform: Capacitor.getPlatform() (android/ios), nicht nur UA/Bridge-Heuristik — vermeidet
 * fälschlich Web-redirectTo in der nativen App.
 *
 * Supabase Dashboard → Authentication → URL Configuration → Additional Redirect URLs:
 * com.hustle.dance://auth-callback
 */
export function getOAuthRedirectTo(options: OAuthRedirectOptions = {}): string {
  const { type = "google", mode, referralCode } = options;

  const q = new URLSearchParams();
  q.set("type", type);
  if (mode) {
    q.set("mode", mode);
  }
  if (referralCode?.trim()) {
    q.set("ref", referralCode.trim());
  }

  const platform = Capacitor.getPlatform();
  const isNative = platform === "android" || platform === "ios";

  let redirectTo: string;
  if (isNative) {
    redirectTo = `${NATIVE_OAUTH_REDIRECT_SCHEME}://${NATIVE_OAUTH_REDIRECT_HOST}?${q.toString()}`;
  } else if (typeof window !== "undefined") {
    redirectTo = `${window.location.origin}/auth/callback?${q.toString()}`;
  } else {
    redirectTo = "";
  }

  if (typeof window !== "undefined") {
    console.log("[OAuth] platform =", platform);
    console.log("[OAuth] redirectTo =", redirectTo);
  }

  return redirectTo;
}
